import React from "react";
import { useLocation, useParams } from "react-router-dom";
import ProductCard from "../../../components/ProductCards";
import HeroSectionPrime from "../../../components/HeroSectionPrime";
import { useProducts } from "../productsProvider";

export default function CategoryPage() {
  // Get the category from the URL parameter
  const { Category } = useParams();

  const { products, loading } = useProducts();


  console.log(products);
  return (
    <div className="w-full py-10">
      <HeroSectionPrime
        imgSrc={require("../../../assets/ProductsHero.png")}
        Align={"text-center"}
        lineHeight={"leading-loose"}
        btnAppear={false}
        title={"Ultrasound Medical Equipment, Systems, and Software"}
        content={`Explore the features and specifications of the equipment that you are considering!`}
        Height={"h-[541px] pt-20"}
      />

      <div className="mx-auto w-[82%]">
        <div className="flex items-start justify-evenly w-full flex-wrap">
          {Array.isArray(products) && products.length > 0 ? (
            products
              .filter((p) =>
                p.clinicalSegments.fieldOfApplication.includes(Category)
              )
              .map((p) => (
                <ProductCard
                  key={p._id}
                  imageSrc={p.images[0].url ? p.images[0].url : p.images[0]}
                  title={p.name}
                  subtitle={p.subName}
                  features={p.feature}
                  description={{
                    title: "Clinical Segments Served",
                    data: "Abdomen and Liver, Critical Care, Emergency Medicine, Musculoskeletal, Pediatrics, ......",
                  }}
                  id={p._id}
                />
              ))
          ) : (
            <p>No products available for this category.</p> // Optional message when no products are found
          )}
        </div>
      </div>
    </div>
  );
}
